import styled from 'styled-components'
import Img from 'react-imgix'

import FilestackImage from './FilestackImage'
import UploadcareImage from './UploadcareImage'

const Image = styled.img.attrs(props => ({
  ...props,
  as: props.src.match(/filestack/) ? FilestackImage : (
    props.src.match(/ucarecdn|cdn\.lineups\.io/) ? UploadcareImage : Img
  ),
}))`
  margin: 0;
  ${props =>
    props.relative
      ? ''
      : `
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center center;
    font-family: 'object-fit: cover; object-position: center center;';
  `}
`

export default Image
